import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  NavbarToggler,
  Collapse,
} from "reactstrap";
import {
  FaUsers,
  FaClipboardList,
  FaSignOutAlt,
  FaChartBar,
  FaUser,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDataContext } from "../Context/dataContext";

function SuperAdminNavbar() {
  const { url, infoTkn } = useDataContext();
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const fetchAdminData = useCallback(async () => {
    try {
      const response = await axios.get(
        `${url}/Auth/findByJWTSuperAdmin/${infoTkn}`,
        {
          headers: { Authorization: `Bearer ${infoTkn}` },
        }
      );

      setAdmin(response.data.data);
    } catch (error) {
      console.error("Error obteniendo datos del administrador:", error);
    }
  }, [url, infoTkn]);

  const handleLogout = async () => {
    await axios.get(`${url}/Auth/logoutSuperAdmin/${admin.sadm_email}`);
    navigate("/SadminLogin");
  };

  useEffect(() => {
    fetchAdminData();
  }, [fetchAdminData]);

  return (
    <Navbar dark expand="md" className="superadmin-navbar px-4">
      {/* Logo a la izquierda */}
      <NavbarBrand href="/" className="superadmin-navbar__logo">
        Super Admin Panel
      </NavbarBrand>

      {/* Botón de hamburguesa */}
      <NavbarToggler onClick={() => setIsOpen(!isOpen)} />

      <Collapse isOpen={isOpen} navbar>
        <Nav className="superadmin-navbar__menu mx-auto" navbar>
          <NavItem className="superadmin-navbar__item">
            <NavLink href="/Dashboard">
              <FaChartBar className="superadmin-navbar__icon" /> Dashboard
            </NavLink>
          </NavItem>
          <NavItem className="superadmin-navbar__item">
            <NavLink href="/UsersAdmins">
              <FaUsers className="superadmin-navbar__icon" /> Gestión de
              Usuarios
            </NavLink>
          </NavItem>
          <NavItem className="superadmin-navbar__item">
            <NavLink href="/Relation">
              <FaClipboardList className="superadmin-navbar__icon" /> Gestión de
              Relacion
            </NavLink>
          </NavItem>
          <NavItem className="superadmin-navbar__item">
            <NavLink href="/AdmProfile">
              <FaUser className="superadmin-navbar__icon" /> Perfil
            </NavLink>
          </NavItem>

          {/* Cerrar sesión SOLO en menú hamburguesa */}
          <NavItem className="superadmin-navbar__logout-mobile">
            <Button
              className="superadmin-navbar__logout"
              onClick={handleLogout}
            >
              <FaSignOutAlt className="superadmin-navbar__icon" /> Cerrar Sesión
            </Button>
          </NavItem>
        </Nav>
      </Collapse>

      {/* Cerrar sesión SOLO en escritorio */}
      <div className="superadmin-navbar__logout-desktop">
        <Button className="superadmin-navbar__logout" onClick={handleLogout}>
          <FaSignOutAlt className="superadmin-navbar__icon" /> Cerrar Sesión
        </Button>
      </div>
    </Navbar>
  );
}

export default SuperAdminNavbar;
